import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { SOTService } from '../../services';

@Component({
  selector: "sot-outoforder",
  templateUrl: "./outoforder.component.html",
  styleUrls: ["./outoforder.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OutofOrderComponent implements OnInit, OnDestroy {

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _sotService: SOTService) { 
    console.debug("--- sot-outoforder constructor")
  }

  public ngOnInit(): void {
    console.debug("--- sot-outoforder ngOnInit")
    this.PushChanges();
  }

  public ngOnDestroy(): void {
    console.debug("--- sot-outoforder ngOnDestroy")
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._sotService.coreLogService.error("OutofOrderComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }
}

